/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupMfaRouteImport } from './routes/setup-mfa'
import { Route as LoginMfaRouteImport } from './routes/login-mfa'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvitationRouteImport } from './routes/invitation'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as ActivateTokenRouteImport } from './routes/activate.$token'
import { Route as AuthenticatedSuperAdminRouteImport } from './routes/_authenticated.super-admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedSuperAdminTeamRouteImport } from './routes/_authenticated.super-admin.team'
import { Route as AuthenticatedDashboardUsersRouteImport } from './routes/_authenticated.dashboard.users'
import { Route as AuthenticatedDashboardSettingsRouteImport } from './routes/_authenticated.dashboard.settings'
import { Route as AuthenticatedDashboardMembershipsRouteImport } from './routes/_authenticated.dashboard.memberships'
import { Route as AuthenticatedDashboardLocationsRouteImport } from './routes/_authenticated.dashboard.locations'
import { Route as AuthenticatedDashboardEventsRouteImport } from './routes/_authenticated.dashboard.events'
import { Route as AuthenticatedSuperAdminQrGeneratorIndexRouteImport } from './routes/_authenticated.super-admin.qr-generator.index'
import { Route as AuthenticatedSuperAdminPlansIndexRouteImport } from './routes/_authenticated.super-admin.plans.index'
import { Route as AuthenticatedSuperAdminOverviewIndexRouteImport } from './routes/_authenticated.super-admin.overview.index'
import { Route as AuthenticatedSuperAdminOrganizationsIndexRouteImport } from './routes/_authenticated.super-admin.organizations.index'
import { Route as AuthenticatedSuperAdminAuditLogIndexRouteImport } from './routes/_authenticated.super-admin.audit-log.index'
import { Route as AuthenticatedDashboardTicketsIndexRouteImport } from './routes/_authenticated.dashboard.tickets.index'
import { Route as AuthenticatedDashboardSupervisorIndexRouteImport } from './routes/_authenticated.dashboard.supervisor.index'
import { Route as AuthenticatedDashboardSettingsIndexRouteImport } from './routes/_authenticated.dashboard.settings.index'
import { Route as AuthenticatedDashboardLocationsIndexRouteImport } from './routes/_authenticated.dashboard.locations.index'
import { Route as AuthenticatedDashboardEventsIndexRouteImport } from './routes/_authenticated.dashboard.events.index'
import { Route as AuthenticatedDashboardAuditLogIndexRouteImport } from './routes/_authenticated.dashboard.audit-log.index'
import { Route as AuthenticatedDashboardAnalyticsIndexRouteImport } from './routes/_authenticated.dashboard.analytics.index'
import { Route as AuthenticatedSuperAdminOrganizationsNewRouteImport } from './routes/_authenticated.super-admin.organizations.new'
import { Route as AuthenticatedSuperAdminOrganizationsOrgIdRouteImport } from './routes/_authenticated.super-admin.organizations.$orgId'
import { Route as AuthenticatedDashboardSmsUndeliveredRouteImport } from './routes/_authenticated.dashboard.sms.undelivered'
import { Route as AuthenticatedDashboardLocationsNewRouteImport } from './routes/_authenticated.dashboard.locations.new'
import { Route as AuthenticatedDashboardEventsNewRouteImport } from './routes/_authenticated.dashboard.events.new'
import { Route as AuthenticatedDashboardTicketsTicketIdIndexRouteImport } from './routes/_authenticated.dashboard.tickets.$ticketId.index'
import { Route as AuthenticatedDashboardSettingsSubscriptionIndexRouteImport } from './routes/_authenticated.dashboard.settings.subscription.index'
import { Route as AuthenticatedDashboardSettingsSmsTemplatesIndexRouteImport } from './routes/_authenticated.dashboard.settings.sms-templates.index'
import { Route as AuthenticatedDashboardSettingsBillingIndexRouteImport } from './routes/_authenticated.dashboard.settings.billing.index'
import { Route as AuthenticatedDashboardMembershipsPlansIndexRouteImport } from './routes/_authenticated.dashboard.memberships.plans.index'
import { Route as AuthenticatedDashboardMembershipsMembersIndexRouteImport } from './routes/_authenticated.dashboard.memberships.members.index'
import { Route as AuthenticatedDashboardLocationsLocationIdEditRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.edit'
import { Route as AuthenticatedDashboardEventsEventIdEditRouteImport } from './routes/_authenticated.dashboard.events.$eventId.edit'
import { Route as AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRouteImport } from './routes/_authenticated.super-admin.qr-generator.$orgId.$locationId.index'
import { Route as AuthenticatedDashboardTicketsTicketIdHistoryIndexRouteImport } from './routes/_authenticated.dashboard.tickets.$ticketId.history.index'
import { Route as AuthenticatedDashboardLocationsLocationIdZonesIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.zones.index'
import { Route as AuthenticatedDashboardLocationsLocationIdTipConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.tip-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.ticket-types-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdTariffIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.tariff.index'
import { Route as AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.station-devices.index'
import { Route as AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.niche-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.hotel-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdCompConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.comp-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.checkin-config.index'
import { Route as AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.assignments.index'
import { Route as AuthenticatedDashboardLocationsLocationIdZonesNewRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.zones.new'
import { Route as AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRouteImport } from './routes/_authenticated.dashboard.locations.$locationId.zones.$zoneId.edit'

const SetupMfaRoute = SetupMfaRouteImport.update({
  id: '/setup-mfa',
  path: '/setup-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMfaRoute = LoginMfaRouteImport.update({
  id: '/login-mfa',
  path: '/login-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateTokenRoute = ActivateTokenRouteImport.update({
  id: '/activate/$token',
  path: '/activate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSuperAdminRoute = AuthenticatedSuperAdminRouteImport.update({
  id: '/super-admin',
  path: '/super-admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSuperAdminTeamRoute =
  AuthenticatedSuperAdminTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedDashboardUsersRoute =
  AuthenticatedDashboardUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsRoute =
  AuthenticatedDashboardSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardMembershipsRoute =
  AuthenticatedDashboardMembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLocationsRoute =
  AuthenticatedDashboardLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardEventsRoute =
  AuthenticatedDashboardEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedSuperAdminQrGeneratorIndexRoute =
  AuthenticatedSuperAdminQrGeneratorIndexRouteImport.update({
    id: '/qr-generator/',
    path: '/qr-generator/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedSuperAdminPlansIndexRoute =
  AuthenticatedSuperAdminPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedSuperAdminOverviewIndexRoute =
  AuthenticatedSuperAdminOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsIndexRoute =
  AuthenticatedSuperAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedSuperAdminAuditLogIndexRoute =
  AuthenticatedSuperAdminAuditLogIndexRouteImport.update({
    id: '/audit-log/',
    path: '/audit-log/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedDashboardTicketsIndexRoute =
  AuthenticatedDashboardTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSupervisorIndexRoute =
  AuthenticatedDashboardSupervisorIndexRouteImport.update({
    id: '/supervisor/',
    path: '/supervisor/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsIndexRoute =
  AuthenticatedDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardLocationsIndexRoute =
  AuthenticatedDashboardLocationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardEventsIndexRoute =
  AuthenticatedDashboardEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardEventsRoute,
  } as any)
const AuthenticatedDashboardAuditLogIndexRoute =
  AuthenticatedDashboardAuditLogIndexRouteImport.update({
    id: '/audit-log/',
    path: '/audit-log/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardAnalyticsIndexRoute =
  AuthenticatedDashboardAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsNewRoute =
  AuthenticatedSuperAdminOrganizationsNewRouteImport.update({
    id: '/organizations/new',
    path: '/organizations/new',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsOrgIdRoute =
  AuthenticatedSuperAdminOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedDashboardSmsUndeliveredRoute =
  AuthenticatedDashboardSmsUndeliveredRouteImport.update({
    id: '/sms/undelivered',
    path: '/sms/undelivered',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLocationsNewRoute =
  AuthenticatedDashboardLocationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardEventsNewRoute =
  AuthenticatedDashboardEventsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedDashboardEventsRoute,
  } as any)
const AuthenticatedDashboardTicketsTicketIdIndexRoute =
  AuthenticatedDashboardTicketsTicketIdIndexRouteImport.update({
    id: '/tickets/$ticketId/',
    path: '/tickets/$ticketId/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsSubscriptionIndexRoute =
  AuthenticatedDashboardSettingsSubscriptionIndexRouteImport.update({
    id: '/subscription/',
    path: '/subscription/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsSmsTemplatesIndexRoute =
  AuthenticatedDashboardSettingsSmsTemplatesIndexRouteImport.update({
    id: '/sms-templates/',
    path: '/sms-templates/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsBillingIndexRoute =
  AuthenticatedDashboardSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardMembershipsPlansIndexRoute =
  AuthenticatedDashboardMembershipsPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => AuthenticatedDashboardMembershipsRoute,
  } as any)
const AuthenticatedDashboardMembershipsMembersIndexRoute =
  AuthenticatedDashboardMembershipsMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedDashboardMembershipsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdEditRoute =
  AuthenticatedDashboardLocationsLocationIdEditRouteImport.update({
    id: '/$locationId/edit',
    path: '/$locationId/edit',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardEventsEventIdEditRoute =
  AuthenticatedDashboardEventsEventIdEditRouteImport.update({
    id: '/$eventId/edit',
    path: '/$eventId/edit',
    getParentRoute: () => AuthenticatedDashboardEventsRoute,
  } as any)
const AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute =
  AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRouteImport.update({
    id: '/qr-generator/$orgId/$locationId/',
    path: '/qr-generator/$orgId/$locationId/',
    getParentRoute: () => AuthenticatedSuperAdminRoute,
  } as any)
const AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute =
  AuthenticatedDashboardTicketsTicketIdHistoryIndexRouteImport.update({
    id: '/tickets/$ticketId/history/',
    path: '/tickets/$ticketId/history/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdZonesIndexRoute =
  AuthenticatedDashboardLocationsLocationIdZonesIndexRouteImport.update({
    id: '/$locationId/zones/',
    path: '/$locationId/zones/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdTipConfigIndexRouteImport.update({
    id: '/$locationId/tip-config/',
    path: '/$locationId/tip-config/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRouteImport.update(
    {
      id: '/$locationId/ticket-types-config/',
      path: '/$locationId/ticket-types-config/',
      getParentRoute: () => AuthenticatedDashboardLocationsRoute,
    } as any,
  )
const AuthenticatedDashboardLocationsLocationIdTariffIndexRoute =
  AuthenticatedDashboardLocationsLocationIdTariffIndexRouteImport.update({
    id: '/$locationId/tariff/',
    path: '/$locationId/tariff/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute =
  AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRouteImport.update(
    {
      id: '/$locationId/station-devices/',
      path: '/$locationId/station-devices/',
      getParentRoute: () => AuthenticatedDashboardLocationsRoute,
    } as any,
  )
const AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRouteImport.update({
    id: '/$locationId/niche-config/',
    path: '/$locationId/niche-config/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRouteImport.update({
    id: '/$locationId/hotel-config/',
    path: '/$locationId/hotel-config/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdCompConfigIndexRouteImport.update({
    id: '/$locationId/comp-config/',
    path: '/$locationId/comp-config/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute =
  AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRouteImport.update(
    {
      id: '/$locationId/checkin-config/',
      path: '/$locationId/checkin-config/',
      getParentRoute: () => AuthenticatedDashboardLocationsRoute,
    } as any,
  )
const AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute =
  AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRouteImport.update({
    id: '/$locationId/assignments/',
    path: '/$locationId/assignments/',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdZonesNewRoute =
  AuthenticatedDashboardLocationsLocationIdZonesNewRouteImport.update({
    id: '/$locationId/zones/new',
    path: '/$locationId/zones/new',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)
const AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute =
  AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRouteImport.update({
    id: '/$locationId/zones/$zoneId/edit',
    path: '/$locationId/zones/$zoneId/edit',
    getParentRoute: () => AuthenticatedDashboardLocationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/login-mfa': typeof LoginMfaRoute
  '/setup-mfa': typeof SetupMfaRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/super-admin': typeof AuthenticatedSuperAdminRouteWithChildren
  '/activate/$token': typeof ActivateTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/dashboard/events': typeof AuthenticatedDashboardEventsRouteWithChildren
  '/dashboard/locations': typeof AuthenticatedDashboardLocationsRouteWithChildren
  '/dashboard/memberships': typeof AuthenticatedDashboardMembershipsRouteWithChildren
  '/dashboard/settings': typeof AuthenticatedDashboardSettingsRouteWithChildren
  '/dashboard/users': typeof AuthenticatedDashboardUsersRoute
  '/super-admin/team': typeof AuthenticatedSuperAdminTeamRoute
  '/dashboard/events/new': typeof AuthenticatedDashboardEventsNewRoute
  '/dashboard/locations/new': typeof AuthenticatedDashboardLocationsNewRoute
  '/dashboard/sms/undelivered': typeof AuthenticatedDashboardSmsUndeliveredRoute
  '/super-admin/organizations/$orgId': typeof AuthenticatedSuperAdminOrganizationsOrgIdRoute
  '/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/dashboard/analytics/': typeof AuthenticatedDashboardAnalyticsIndexRoute
  '/dashboard/audit-log/': typeof AuthenticatedDashboardAuditLogIndexRoute
  '/dashboard/events/': typeof AuthenticatedDashboardEventsIndexRoute
  '/dashboard/locations/': typeof AuthenticatedDashboardLocationsIndexRoute
  '/dashboard/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/dashboard/supervisor/': typeof AuthenticatedDashboardSupervisorIndexRoute
  '/dashboard/tickets/': typeof AuthenticatedDashboardTicketsIndexRoute
  '/super-admin/audit-log/': typeof AuthenticatedSuperAdminAuditLogIndexRoute
  '/super-admin/organizations/': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/super-admin/overview/': typeof AuthenticatedSuperAdminOverviewIndexRoute
  '/super-admin/plans/': typeof AuthenticatedSuperAdminPlansIndexRoute
  '/super-admin/qr-generator/': typeof AuthenticatedSuperAdminQrGeneratorIndexRoute
  '/dashboard/events/$eventId/edit': typeof AuthenticatedDashboardEventsEventIdEditRoute
  '/dashboard/locations/$locationId/edit': typeof AuthenticatedDashboardLocationsLocationIdEditRoute
  '/dashboard/memberships/members/': typeof AuthenticatedDashboardMembershipsMembersIndexRoute
  '/dashboard/memberships/plans/': typeof AuthenticatedDashboardMembershipsPlansIndexRoute
  '/dashboard/settings/billing/': typeof AuthenticatedDashboardSettingsBillingIndexRoute
  '/dashboard/settings/sms-templates/': typeof AuthenticatedDashboardSettingsSmsTemplatesIndexRoute
  '/dashboard/settings/subscription/': typeof AuthenticatedDashboardSettingsSubscriptionIndexRoute
  '/dashboard/tickets/$ticketId/': typeof AuthenticatedDashboardTicketsTicketIdIndexRoute
  '/dashboard/locations/$locationId/zones/new': typeof AuthenticatedDashboardLocationsLocationIdZonesNewRoute
  '/dashboard/locations/$locationId/assignments/': typeof AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute
  '/dashboard/locations/$locationId/checkin-config/': typeof AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute
  '/dashboard/locations/$locationId/comp-config/': typeof AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute
  '/dashboard/locations/$locationId/hotel-config/': typeof AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute
  '/dashboard/locations/$locationId/niche-config/': typeof AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute
  '/dashboard/locations/$locationId/station-devices/': typeof AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute
  '/dashboard/locations/$locationId/tariff/': typeof AuthenticatedDashboardLocationsLocationIdTariffIndexRoute
  '/dashboard/locations/$locationId/ticket-types-config/': typeof AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute
  '/dashboard/locations/$locationId/tip-config/': typeof AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute
  '/dashboard/locations/$locationId/zones/': typeof AuthenticatedDashboardLocationsLocationIdZonesIndexRoute
  '/dashboard/tickets/$ticketId/history/': typeof AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute
  '/super-admin/qr-generator/$orgId/$locationId/': typeof AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute
  '/dashboard/locations/$locationId/zones/$zoneId/edit': typeof AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/login-mfa': typeof LoginMfaRoute
  '/setup-mfa': typeof SetupMfaRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/super-admin': typeof AuthenticatedSuperAdminRouteWithChildren
  '/activate/$token': typeof ActivateTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/dashboard/memberships': typeof AuthenticatedDashboardMembershipsRouteWithChildren
  '/dashboard/users': typeof AuthenticatedDashboardUsersRoute
  '/super-admin/team': typeof AuthenticatedSuperAdminTeamRoute
  '/dashboard/events/new': typeof AuthenticatedDashboardEventsNewRoute
  '/dashboard/locations/new': typeof AuthenticatedDashboardLocationsNewRoute
  '/dashboard/sms/undelivered': typeof AuthenticatedDashboardSmsUndeliveredRoute
  '/super-admin/organizations/$orgId': typeof AuthenticatedSuperAdminOrganizationsOrgIdRoute
  '/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/dashboard/analytics': typeof AuthenticatedDashboardAnalyticsIndexRoute
  '/dashboard/audit-log': typeof AuthenticatedDashboardAuditLogIndexRoute
  '/dashboard/events': typeof AuthenticatedDashboardEventsIndexRoute
  '/dashboard/locations': typeof AuthenticatedDashboardLocationsIndexRoute
  '/dashboard/settings': typeof AuthenticatedDashboardSettingsIndexRoute
  '/dashboard/supervisor': typeof AuthenticatedDashboardSupervisorIndexRoute
  '/dashboard/tickets': typeof AuthenticatedDashboardTicketsIndexRoute
  '/super-admin/audit-log': typeof AuthenticatedSuperAdminAuditLogIndexRoute
  '/super-admin/organizations': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/super-admin/overview': typeof AuthenticatedSuperAdminOverviewIndexRoute
  '/super-admin/plans': typeof AuthenticatedSuperAdminPlansIndexRoute
  '/super-admin/qr-generator': typeof AuthenticatedSuperAdminQrGeneratorIndexRoute
  '/dashboard/events/$eventId/edit': typeof AuthenticatedDashboardEventsEventIdEditRoute
  '/dashboard/locations/$locationId/edit': typeof AuthenticatedDashboardLocationsLocationIdEditRoute
  '/dashboard/memberships/members': typeof AuthenticatedDashboardMembershipsMembersIndexRoute
  '/dashboard/memberships/plans': typeof AuthenticatedDashboardMembershipsPlansIndexRoute
  '/dashboard/settings/billing': typeof AuthenticatedDashboardSettingsBillingIndexRoute
  '/dashboard/settings/sms-templates': typeof AuthenticatedDashboardSettingsSmsTemplatesIndexRoute
  '/dashboard/settings/subscription': typeof AuthenticatedDashboardSettingsSubscriptionIndexRoute
  '/dashboard/tickets/$ticketId': typeof AuthenticatedDashboardTicketsTicketIdIndexRoute
  '/dashboard/locations/$locationId/zones/new': typeof AuthenticatedDashboardLocationsLocationIdZonesNewRoute
  '/dashboard/locations/$locationId/assignments': typeof AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute
  '/dashboard/locations/$locationId/checkin-config': typeof AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute
  '/dashboard/locations/$locationId/comp-config': typeof AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute
  '/dashboard/locations/$locationId/hotel-config': typeof AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute
  '/dashboard/locations/$locationId/niche-config': typeof AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute
  '/dashboard/locations/$locationId/station-devices': typeof AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute
  '/dashboard/locations/$locationId/tariff': typeof AuthenticatedDashboardLocationsLocationIdTariffIndexRoute
  '/dashboard/locations/$locationId/ticket-types-config': typeof AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute
  '/dashboard/locations/$locationId/tip-config': typeof AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute
  '/dashboard/locations/$locationId/zones': typeof AuthenticatedDashboardLocationsLocationIdZonesIndexRoute
  '/dashboard/tickets/$ticketId/history': typeof AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute
  '/super-admin/qr-generator/$orgId/$locationId': typeof AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute
  '/dashboard/locations/$locationId/zones/$zoneId/edit': typeof AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/login-mfa': typeof LoginMfaRoute
  '/setup-mfa': typeof SetupMfaRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/super-admin': typeof AuthenticatedSuperAdminRouteWithChildren
  '/activate/$token': typeof ActivateTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_authenticated/dashboard/events': typeof AuthenticatedDashboardEventsRouteWithChildren
  '/_authenticated/dashboard/locations': typeof AuthenticatedDashboardLocationsRouteWithChildren
  '/_authenticated/dashboard/memberships': typeof AuthenticatedDashboardMembershipsRouteWithChildren
  '/_authenticated/dashboard/settings': typeof AuthenticatedDashboardSettingsRouteWithChildren
  '/_authenticated/dashboard/users': typeof AuthenticatedDashboardUsersRoute
  '/_authenticated/super-admin/team': typeof AuthenticatedSuperAdminTeamRoute
  '/_authenticated/dashboard/events/new': typeof AuthenticatedDashboardEventsNewRoute
  '/_authenticated/dashboard/locations/new': typeof AuthenticatedDashboardLocationsNewRoute
  '/_authenticated/dashboard/sms/undelivered': typeof AuthenticatedDashboardSmsUndeliveredRoute
  '/_authenticated/super-admin/organizations/$orgId': typeof AuthenticatedSuperAdminOrganizationsOrgIdRoute
  '/_authenticated/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/_authenticated/dashboard/analytics/': typeof AuthenticatedDashboardAnalyticsIndexRoute
  '/_authenticated/dashboard/audit-log/': typeof AuthenticatedDashboardAuditLogIndexRoute
  '/_authenticated/dashboard/events/': typeof AuthenticatedDashboardEventsIndexRoute
  '/_authenticated/dashboard/locations/': typeof AuthenticatedDashboardLocationsIndexRoute
  '/_authenticated/dashboard/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/_authenticated/dashboard/supervisor/': typeof AuthenticatedDashboardSupervisorIndexRoute
  '/_authenticated/dashboard/tickets/': typeof AuthenticatedDashboardTicketsIndexRoute
  '/_authenticated/super-admin/audit-log/': typeof AuthenticatedSuperAdminAuditLogIndexRoute
  '/_authenticated/super-admin/organizations/': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/_authenticated/super-admin/overview/': typeof AuthenticatedSuperAdminOverviewIndexRoute
  '/_authenticated/super-admin/plans/': typeof AuthenticatedSuperAdminPlansIndexRoute
  '/_authenticated/super-admin/qr-generator/': typeof AuthenticatedSuperAdminQrGeneratorIndexRoute
  '/_authenticated/dashboard/events/$eventId/edit': typeof AuthenticatedDashboardEventsEventIdEditRoute
  '/_authenticated/dashboard/locations/$locationId/edit': typeof AuthenticatedDashboardLocationsLocationIdEditRoute
  '/_authenticated/dashboard/memberships/members/': typeof AuthenticatedDashboardMembershipsMembersIndexRoute
  '/_authenticated/dashboard/memberships/plans/': typeof AuthenticatedDashboardMembershipsPlansIndexRoute
  '/_authenticated/dashboard/settings/billing/': typeof AuthenticatedDashboardSettingsBillingIndexRoute
  '/_authenticated/dashboard/settings/sms-templates/': typeof AuthenticatedDashboardSettingsSmsTemplatesIndexRoute
  '/_authenticated/dashboard/settings/subscription/': typeof AuthenticatedDashboardSettingsSubscriptionIndexRoute
  '/_authenticated/dashboard/tickets/$ticketId/': typeof AuthenticatedDashboardTicketsTicketIdIndexRoute
  '/_authenticated/dashboard/locations/$locationId/zones/new': typeof AuthenticatedDashboardLocationsLocationIdZonesNewRoute
  '/_authenticated/dashboard/locations/$locationId/assignments/': typeof AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute
  '/_authenticated/dashboard/locations/$locationId/checkin-config/': typeof AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/comp-config/': typeof AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/hotel-config/': typeof AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/niche-config/': typeof AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/station-devices/': typeof AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute
  '/_authenticated/dashboard/locations/$locationId/tariff/': typeof AuthenticatedDashboardLocationsLocationIdTariffIndexRoute
  '/_authenticated/dashboard/locations/$locationId/ticket-types-config/': typeof AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/tip-config/': typeof AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute
  '/_authenticated/dashboard/locations/$locationId/zones/': typeof AuthenticatedDashboardLocationsLocationIdZonesIndexRoute
  '/_authenticated/dashboard/tickets/$ticketId/history/': typeof AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute
  '/_authenticated/super-admin/qr-generator/$orgId/$locationId/': typeof AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute
  '/_authenticated/dashboard/locations/$locationId/zones/$zoneId/edit': typeof AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/login-mfa'
    | '/setup-mfa'
    | '/dashboard'
    | '/super-admin'
    | '/activate/$token'
    | '/reset-password/$token'
    | '/dashboard/events'
    | '/dashboard/locations'
    | '/dashboard/memberships'
    | '/dashboard/settings'
    | '/dashboard/users'
    | '/super-admin/team'
    | '/dashboard/events/new'
    | '/dashboard/locations/new'
    | '/dashboard/sms/undelivered'
    | '/super-admin/organizations/$orgId'
    | '/super-admin/organizations/new'
    | '/dashboard/analytics/'
    | '/dashboard/audit-log/'
    | '/dashboard/events/'
    | '/dashboard/locations/'
    | '/dashboard/settings/'
    | '/dashboard/supervisor/'
    | '/dashboard/tickets/'
    | '/super-admin/audit-log/'
    | '/super-admin/organizations/'
    | '/super-admin/overview/'
    | '/super-admin/plans/'
    | '/super-admin/qr-generator/'
    | '/dashboard/events/$eventId/edit'
    | '/dashboard/locations/$locationId/edit'
    | '/dashboard/memberships/members/'
    | '/dashboard/memberships/plans/'
    | '/dashboard/settings/billing/'
    | '/dashboard/settings/sms-templates/'
    | '/dashboard/settings/subscription/'
    | '/dashboard/tickets/$ticketId/'
    | '/dashboard/locations/$locationId/zones/new'
    | '/dashboard/locations/$locationId/assignments/'
    | '/dashboard/locations/$locationId/checkin-config/'
    | '/dashboard/locations/$locationId/comp-config/'
    | '/dashboard/locations/$locationId/hotel-config/'
    | '/dashboard/locations/$locationId/niche-config/'
    | '/dashboard/locations/$locationId/station-devices/'
    | '/dashboard/locations/$locationId/tariff/'
    | '/dashboard/locations/$locationId/ticket-types-config/'
    | '/dashboard/locations/$locationId/tip-config/'
    | '/dashboard/locations/$locationId/zones/'
    | '/dashboard/tickets/$ticketId/history/'
    | '/super-admin/qr-generator/$orgId/$locationId/'
    | '/dashboard/locations/$locationId/zones/$zoneId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/login-mfa'
    | '/setup-mfa'
    | '/dashboard'
    | '/super-admin'
    | '/activate/$token'
    | '/reset-password/$token'
    | '/dashboard/memberships'
    | '/dashboard/users'
    | '/super-admin/team'
    | '/dashboard/events/new'
    | '/dashboard/locations/new'
    | '/dashboard/sms/undelivered'
    | '/super-admin/organizations/$orgId'
    | '/super-admin/organizations/new'
    | '/dashboard/analytics'
    | '/dashboard/audit-log'
    | '/dashboard/events'
    | '/dashboard/locations'
    | '/dashboard/settings'
    | '/dashboard/supervisor'
    | '/dashboard/tickets'
    | '/super-admin/audit-log'
    | '/super-admin/organizations'
    | '/super-admin/overview'
    | '/super-admin/plans'
    | '/super-admin/qr-generator'
    | '/dashboard/events/$eventId/edit'
    | '/dashboard/locations/$locationId/edit'
    | '/dashboard/memberships/members'
    | '/dashboard/memberships/plans'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/sms-templates'
    | '/dashboard/settings/subscription'
    | '/dashboard/tickets/$ticketId'
    | '/dashboard/locations/$locationId/zones/new'
    | '/dashboard/locations/$locationId/assignments'
    | '/dashboard/locations/$locationId/checkin-config'
    | '/dashboard/locations/$locationId/comp-config'
    | '/dashboard/locations/$locationId/hotel-config'
    | '/dashboard/locations/$locationId/niche-config'
    | '/dashboard/locations/$locationId/station-devices'
    | '/dashboard/locations/$locationId/tariff'
    | '/dashboard/locations/$locationId/ticket-types-config'
    | '/dashboard/locations/$locationId/tip-config'
    | '/dashboard/locations/$locationId/zones'
    | '/dashboard/tickets/$ticketId/history'
    | '/super-admin/qr-generator/$orgId/$locationId'
    | '/dashboard/locations/$locationId/zones/$zoneId/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/login-mfa'
    | '/setup-mfa'
    | '/_authenticated/dashboard'
    | '/_authenticated/super-admin'
    | '/activate/$token'
    | '/reset-password/$token'
    | '/_authenticated/dashboard/events'
    | '/_authenticated/dashboard/locations'
    | '/_authenticated/dashboard/memberships'
    | '/_authenticated/dashboard/settings'
    | '/_authenticated/dashboard/users'
    | '/_authenticated/super-admin/team'
    | '/_authenticated/dashboard/events/new'
    | '/_authenticated/dashboard/locations/new'
    | '/_authenticated/dashboard/sms/undelivered'
    | '/_authenticated/super-admin/organizations/$orgId'
    | '/_authenticated/super-admin/organizations/new'
    | '/_authenticated/dashboard/analytics/'
    | '/_authenticated/dashboard/audit-log/'
    | '/_authenticated/dashboard/events/'
    | '/_authenticated/dashboard/locations/'
    | '/_authenticated/dashboard/settings/'
    | '/_authenticated/dashboard/supervisor/'
    | '/_authenticated/dashboard/tickets/'
    | '/_authenticated/super-admin/audit-log/'
    | '/_authenticated/super-admin/organizations/'
    | '/_authenticated/super-admin/overview/'
    | '/_authenticated/super-admin/plans/'
    | '/_authenticated/super-admin/qr-generator/'
    | '/_authenticated/dashboard/events/$eventId/edit'
    | '/_authenticated/dashboard/locations/$locationId/edit'
    | '/_authenticated/dashboard/memberships/members/'
    | '/_authenticated/dashboard/memberships/plans/'
    | '/_authenticated/dashboard/settings/billing/'
    | '/_authenticated/dashboard/settings/sms-templates/'
    | '/_authenticated/dashboard/settings/subscription/'
    | '/_authenticated/dashboard/tickets/$ticketId/'
    | '/_authenticated/dashboard/locations/$locationId/zones/new'
    | '/_authenticated/dashboard/locations/$locationId/assignments/'
    | '/_authenticated/dashboard/locations/$locationId/checkin-config/'
    | '/_authenticated/dashboard/locations/$locationId/comp-config/'
    | '/_authenticated/dashboard/locations/$locationId/hotel-config/'
    | '/_authenticated/dashboard/locations/$locationId/niche-config/'
    | '/_authenticated/dashboard/locations/$locationId/station-devices/'
    | '/_authenticated/dashboard/locations/$locationId/tariff/'
    | '/_authenticated/dashboard/locations/$locationId/ticket-types-config/'
    | '/_authenticated/dashboard/locations/$locationId/tip-config/'
    | '/_authenticated/dashboard/locations/$locationId/zones/'
    | '/_authenticated/dashboard/tickets/$ticketId/history/'
    | '/_authenticated/super-admin/qr-generator/$orgId/$locationId/'
    | '/_authenticated/dashboard/locations/$locationId/zones/$zoneId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InvitationRoute: typeof InvitationRoute
  LoginRoute: typeof LoginRoute
  LoginMfaRoute: typeof LoginMfaRoute
  SetupMfaRoute: typeof SetupMfaRoute
  ActivateTokenRoute: typeof ActivateTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup-mfa': {
      id: '/setup-mfa'
      path: '/setup-mfa'
      fullPath: '/setup-mfa'
      preLoaderRoute: typeof SetupMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-mfa': {
      id: '/login-mfa'
      path: '/login-mfa'
      fullPath: '/login-mfa'
      preLoaderRoute: typeof LoginMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate/$token': {
      id: '/activate/$token'
      path: '/activate/$token'
      fullPath: '/activate/$token'
      preLoaderRoute: typeof ActivateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/super-admin': {
      id: '/_authenticated/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthenticatedSuperAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/super-admin/team': {
      id: '/_authenticated/super-admin/team'
      path: '/team'
      fullPath: '/super-admin/team'
      preLoaderRoute: typeof AuthenticatedSuperAdminTeamRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/dashboard/users': {
      id: '/_authenticated/dashboard/users'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof AuthenticatedDashboardUsersRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/settings': {
      id: '/_authenticated/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/memberships': {
      id: '/_authenticated/dashboard/memberships'
      path: '/memberships'
      fullPath: '/dashboard/memberships'
      preLoaderRoute: typeof AuthenticatedDashboardMembershipsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/locations': {
      id: '/_authenticated/dashboard/locations'
      path: '/locations'
      fullPath: '/dashboard/locations'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/events': {
      id: '/_authenticated/dashboard/events'
      path: '/events'
      fullPath: '/dashboard/events'
      preLoaderRoute: typeof AuthenticatedDashboardEventsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/super-admin/qr-generator/': {
      id: '/_authenticated/super-admin/qr-generator/'
      path: '/qr-generator'
      fullPath: '/super-admin/qr-generator/'
      preLoaderRoute: typeof AuthenticatedSuperAdminQrGeneratorIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/super-admin/plans/': {
      id: '/_authenticated/super-admin/plans/'
      path: '/plans'
      fullPath: '/super-admin/plans/'
      preLoaderRoute: typeof AuthenticatedSuperAdminPlansIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/super-admin/overview/': {
      id: '/_authenticated/super-admin/overview/'
      path: '/overview'
      fullPath: '/super-admin/overview/'
      preLoaderRoute: typeof AuthenticatedSuperAdminOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/super-admin/organizations/': {
      id: '/_authenticated/super-admin/organizations/'
      path: '/organizations'
      fullPath: '/super-admin/organizations/'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/super-admin/audit-log/': {
      id: '/_authenticated/super-admin/audit-log/'
      path: '/audit-log'
      fullPath: '/super-admin/audit-log/'
      preLoaderRoute: typeof AuthenticatedSuperAdminAuditLogIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/dashboard/tickets/': {
      id: '/_authenticated/dashboard/tickets/'
      path: '/tickets'
      fullPath: '/dashboard/tickets/'
      preLoaderRoute: typeof AuthenticatedDashboardTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/supervisor/': {
      id: '/_authenticated/dashboard/supervisor/'
      path: '/supervisor'
      fullPath: '/dashboard/supervisor/'
      preLoaderRoute: typeof AuthenticatedDashboardSupervisorIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/settings/': {
      id: '/_authenticated/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/dashboard/locations/': {
      id: '/_authenticated/dashboard/locations/'
      path: '/'
      fullPath: '/dashboard/locations/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/events/': {
      id: '/_authenticated/dashboard/events/'
      path: '/'
      fullPath: '/dashboard/events/'
      preLoaderRoute: typeof AuthenticatedDashboardEventsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardEventsRoute
    }
    '/_authenticated/dashboard/audit-log/': {
      id: '/_authenticated/dashboard/audit-log/'
      path: '/audit-log'
      fullPath: '/dashboard/audit-log/'
      preLoaderRoute: typeof AuthenticatedDashboardAuditLogIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/analytics/': {
      id: '/_authenticated/dashboard/analytics/'
      path: '/analytics'
      fullPath: '/dashboard/analytics/'
      preLoaderRoute: typeof AuthenticatedDashboardAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/super-admin/organizations/new': {
      id: '/_authenticated/super-admin/organizations/new'
      path: '/organizations/new'
      fullPath: '/super-admin/organizations/new'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsNewRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/super-admin/organizations/$orgId': {
      id: '/_authenticated/super-admin/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/super-admin/organizations/$orgId'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/dashboard/sms/undelivered': {
      id: '/_authenticated/dashboard/sms/undelivered'
      path: '/sms/undelivered'
      fullPath: '/dashboard/sms/undelivered'
      preLoaderRoute: typeof AuthenticatedDashboardSmsUndeliveredRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/locations/new': {
      id: '/_authenticated/dashboard/locations/new'
      path: '/new'
      fullPath: '/dashboard/locations/new'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsNewRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/events/new': {
      id: '/_authenticated/dashboard/events/new'
      path: '/new'
      fullPath: '/dashboard/events/new'
      preLoaderRoute: typeof AuthenticatedDashboardEventsNewRouteImport
      parentRoute: typeof AuthenticatedDashboardEventsRoute
    }
    '/_authenticated/dashboard/tickets/$ticketId/': {
      id: '/_authenticated/dashboard/tickets/$ticketId/'
      path: '/tickets/$ticketId'
      fullPath: '/dashboard/tickets/$ticketId/'
      preLoaderRoute: typeof AuthenticatedDashboardTicketsTicketIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/settings/subscription/': {
      id: '/_authenticated/dashboard/settings/subscription/'
      path: '/subscription'
      fullPath: '/dashboard/settings/subscription/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsSubscriptionIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/dashboard/settings/sms-templates/': {
      id: '/_authenticated/dashboard/settings/sms-templates/'
      path: '/sms-templates'
      fullPath: '/dashboard/settings/sms-templates/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsSmsTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/dashboard/settings/billing/': {
      id: '/_authenticated/dashboard/settings/billing/'
      path: '/billing'
      fullPath: '/dashboard/settings/billing/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/dashboard/memberships/plans/': {
      id: '/_authenticated/dashboard/memberships/plans/'
      path: '/plans'
      fullPath: '/dashboard/memberships/plans/'
      preLoaderRoute: typeof AuthenticatedDashboardMembershipsPlansIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardMembershipsRoute
    }
    '/_authenticated/dashboard/memberships/members/': {
      id: '/_authenticated/dashboard/memberships/members/'
      path: '/members'
      fullPath: '/dashboard/memberships/members/'
      preLoaderRoute: typeof AuthenticatedDashboardMembershipsMembersIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardMembershipsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/edit': {
      id: '/_authenticated/dashboard/locations/$locationId/edit'
      path: '/$locationId/edit'
      fullPath: '/dashboard/locations/$locationId/edit'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdEditRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/events/$eventId/edit': {
      id: '/_authenticated/dashboard/events/$eventId/edit'
      path: '/$eventId/edit'
      fullPath: '/dashboard/events/$eventId/edit'
      preLoaderRoute: typeof AuthenticatedDashboardEventsEventIdEditRouteImport
      parentRoute: typeof AuthenticatedDashboardEventsRoute
    }
    '/_authenticated/super-admin/qr-generator/$orgId/$locationId/': {
      id: '/_authenticated/super-admin/qr-generator/$orgId/$locationId/'
      path: '/qr-generator/$orgId/$locationId'
      fullPath: '/super-admin/qr-generator/$orgId/$locationId/'
      preLoaderRoute: typeof AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRoute
    }
    '/_authenticated/dashboard/tickets/$ticketId/history/': {
      id: '/_authenticated/dashboard/tickets/$ticketId/history/'
      path: '/tickets/$ticketId/history'
      fullPath: '/dashboard/tickets/$ticketId/history/'
      preLoaderRoute: typeof AuthenticatedDashboardTicketsTicketIdHistoryIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/locations/$locationId/zones/': {
      id: '/_authenticated/dashboard/locations/$locationId/zones/'
      path: '/$locationId/zones'
      fullPath: '/dashboard/locations/$locationId/zones/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/tip-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/tip-config/'
      path: '/$locationId/tip-config'
      fullPath: '/dashboard/locations/$locationId/tip-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdTipConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/ticket-types-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/ticket-types-config/'
      path: '/$locationId/ticket-types-config'
      fullPath: '/dashboard/locations/$locationId/ticket-types-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/tariff/': {
      id: '/_authenticated/dashboard/locations/$locationId/tariff/'
      path: '/$locationId/tariff'
      fullPath: '/dashboard/locations/$locationId/tariff/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdTariffIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/station-devices/': {
      id: '/_authenticated/dashboard/locations/$locationId/station-devices/'
      path: '/$locationId/station-devices'
      fullPath: '/dashboard/locations/$locationId/station-devices/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/niche-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/niche-config/'
      path: '/$locationId/niche-config'
      fullPath: '/dashboard/locations/$locationId/niche-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/hotel-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/hotel-config/'
      path: '/$locationId/hotel-config'
      fullPath: '/dashboard/locations/$locationId/hotel-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/comp-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/comp-config/'
      path: '/$locationId/comp-config'
      fullPath: '/dashboard/locations/$locationId/comp-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdCompConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/checkin-config/': {
      id: '/_authenticated/dashboard/locations/$locationId/checkin-config/'
      path: '/$locationId/checkin-config'
      fullPath: '/dashboard/locations/$locationId/checkin-config/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/assignments/': {
      id: '/_authenticated/dashboard/locations/$locationId/assignments/'
      path: '/$locationId/assignments'
      fullPath: '/dashboard/locations/$locationId/assignments/'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/zones/new': {
      id: '/_authenticated/dashboard/locations/$locationId/zones/new'
      path: '/$locationId/zones/new'
      fullPath: '/dashboard/locations/$locationId/zones/new'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesNewRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
    '/_authenticated/dashboard/locations/$locationId/zones/$zoneId/edit': {
      id: '/_authenticated/dashboard/locations/$locationId/zones/$zoneId/edit'
      path: '/$locationId/zones/$zoneId/edit'
      fullPath: '/dashboard/locations/$locationId/zones/$zoneId/edit'
      preLoaderRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRouteImport
      parentRoute: typeof AuthenticatedDashboardLocationsRoute
    }
  }
}

interface AuthenticatedDashboardEventsRouteChildren {
  AuthenticatedDashboardEventsNewRoute: typeof AuthenticatedDashboardEventsNewRoute
  AuthenticatedDashboardEventsIndexRoute: typeof AuthenticatedDashboardEventsIndexRoute
  AuthenticatedDashboardEventsEventIdEditRoute: typeof AuthenticatedDashboardEventsEventIdEditRoute
}

const AuthenticatedDashboardEventsRouteChildren: AuthenticatedDashboardEventsRouteChildren =
  {
    AuthenticatedDashboardEventsNewRoute: AuthenticatedDashboardEventsNewRoute,
    AuthenticatedDashboardEventsIndexRoute:
      AuthenticatedDashboardEventsIndexRoute,
    AuthenticatedDashboardEventsEventIdEditRoute:
      AuthenticatedDashboardEventsEventIdEditRoute,
  }

const AuthenticatedDashboardEventsRouteWithChildren =
  AuthenticatedDashboardEventsRoute._addFileChildren(
    AuthenticatedDashboardEventsRouteChildren,
  )

interface AuthenticatedDashboardLocationsRouteChildren {
  AuthenticatedDashboardLocationsNewRoute: typeof AuthenticatedDashboardLocationsNewRoute
  AuthenticatedDashboardLocationsIndexRoute: typeof AuthenticatedDashboardLocationsIndexRoute
  AuthenticatedDashboardLocationsLocationIdEditRoute: typeof AuthenticatedDashboardLocationsLocationIdEditRoute
  AuthenticatedDashboardLocationsLocationIdZonesNewRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesNewRoute
  AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute
  AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute
  AuthenticatedDashboardLocationsLocationIdTariffIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdTariffIndexRoute
  AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute
  AuthenticatedDashboardLocationsLocationIdZonesIndexRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesIndexRoute
  AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute: typeof AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute
}

const AuthenticatedDashboardLocationsRouteChildren: AuthenticatedDashboardLocationsRouteChildren =
  {
    AuthenticatedDashboardLocationsNewRoute:
      AuthenticatedDashboardLocationsNewRoute,
    AuthenticatedDashboardLocationsIndexRoute:
      AuthenticatedDashboardLocationsIndexRoute,
    AuthenticatedDashboardLocationsLocationIdEditRoute:
      AuthenticatedDashboardLocationsLocationIdEditRoute,
    AuthenticatedDashboardLocationsLocationIdZonesNewRoute:
      AuthenticatedDashboardLocationsLocationIdZonesNewRoute,
    AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute:
      AuthenticatedDashboardLocationsLocationIdAssignmentsIndexRoute,
    AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdCheckinConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdCompConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdHotelConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdNicheConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute:
      AuthenticatedDashboardLocationsLocationIdStationDevicesIndexRoute,
    AuthenticatedDashboardLocationsLocationIdTariffIndexRoute:
      AuthenticatedDashboardLocationsLocationIdTariffIndexRoute,
    AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdTicketTypesConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute:
      AuthenticatedDashboardLocationsLocationIdTipConfigIndexRoute,
    AuthenticatedDashboardLocationsLocationIdZonesIndexRoute:
      AuthenticatedDashboardLocationsLocationIdZonesIndexRoute,
    AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute:
      AuthenticatedDashboardLocationsLocationIdZonesZoneIdEditRoute,
  }

const AuthenticatedDashboardLocationsRouteWithChildren =
  AuthenticatedDashboardLocationsRoute._addFileChildren(
    AuthenticatedDashboardLocationsRouteChildren,
  )

interface AuthenticatedDashboardMembershipsRouteChildren {
  AuthenticatedDashboardMembershipsMembersIndexRoute: typeof AuthenticatedDashboardMembershipsMembersIndexRoute
  AuthenticatedDashboardMembershipsPlansIndexRoute: typeof AuthenticatedDashboardMembershipsPlansIndexRoute
}

const AuthenticatedDashboardMembershipsRouteChildren: AuthenticatedDashboardMembershipsRouteChildren =
  {
    AuthenticatedDashboardMembershipsMembersIndexRoute:
      AuthenticatedDashboardMembershipsMembersIndexRoute,
    AuthenticatedDashboardMembershipsPlansIndexRoute:
      AuthenticatedDashboardMembershipsPlansIndexRoute,
  }

const AuthenticatedDashboardMembershipsRouteWithChildren =
  AuthenticatedDashboardMembershipsRoute._addFileChildren(
    AuthenticatedDashboardMembershipsRouteChildren,
  )

interface AuthenticatedDashboardSettingsRouteChildren {
  AuthenticatedDashboardSettingsIndexRoute: typeof AuthenticatedDashboardSettingsIndexRoute
  AuthenticatedDashboardSettingsBillingIndexRoute: typeof AuthenticatedDashboardSettingsBillingIndexRoute
  AuthenticatedDashboardSettingsSmsTemplatesIndexRoute: typeof AuthenticatedDashboardSettingsSmsTemplatesIndexRoute
  AuthenticatedDashboardSettingsSubscriptionIndexRoute: typeof AuthenticatedDashboardSettingsSubscriptionIndexRoute
}

const AuthenticatedDashboardSettingsRouteChildren: AuthenticatedDashboardSettingsRouteChildren =
  {
    AuthenticatedDashboardSettingsIndexRoute:
      AuthenticatedDashboardSettingsIndexRoute,
    AuthenticatedDashboardSettingsBillingIndexRoute:
      AuthenticatedDashboardSettingsBillingIndexRoute,
    AuthenticatedDashboardSettingsSmsTemplatesIndexRoute:
      AuthenticatedDashboardSettingsSmsTemplatesIndexRoute,
    AuthenticatedDashboardSettingsSubscriptionIndexRoute:
      AuthenticatedDashboardSettingsSubscriptionIndexRoute,
  }

const AuthenticatedDashboardSettingsRouteWithChildren =
  AuthenticatedDashboardSettingsRoute._addFileChildren(
    AuthenticatedDashboardSettingsRouteChildren,
  )

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardEventsRoute: typeof AuthenticatedDashboardEventsRouteWithChildren
  AuthenticatedDashboardLocationsRoute: typeof AuthenticatedDashboardLocationsRouteWithChildren
  AuthenticatedDashboardMembershipsRoute: typeof AuthenticatedDashboardMembershipsRouteWithChildren
  AuthenticatedDashboardSettingsRoute: typeof AuthenticatedDashboardSettingsRouteWithChildren
  AuthenticatedDashboardUsersRoute: typeof AuthenticatedDashboardUsersRoute
  AuthenticatedDashboardSmsUndeliveredRoute: typeof AuthenticatedDashboardSmsUndeliveredRoute
  AuthenticatedDashboardAnalyticsIndexRoute: typeof AuthenticatedDashboardAnalyticsIndexRoute
  AuthenticatedDashboardAuditLogIndexRoute: typeof AuthenticatedDashboardAuditLogIndexRoute
  AuthenticatedDashboardSupervisorIndexRoute: typeof AuthenticatedDashboardSupervisorIndexRoute
  AuthenticatedDashboardTicketsIndexRoute: typeof AuthenticatedDashboardTicketsIndexRoute
  AuthenticatedDashboardTicketsTicketIdIndexRoute: typeof AuthenticatedDashboardTicketsTicketIdIndexRoute
  AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute: typeof AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardEventsRoute:
      AuthenticatedDashboardEventsRouteWithChildren,
    AuthenticatedDashboardLocationsRoute:
      AuthenticatedDashboardLocationsRouteWithChildren,
    AuthenticatedDashboardMembershipsRoute:
      AuthenticatedDashboardMembershipsRouteWithChildren,
    AuthenticatedDashboardSettingsRoute:
      AuthenticatedDashboardSettingsRouteWithChildren,
    AuthenticatedDashboardUsersRoute: AuthenticatedDashboardUsersRoute,
    AuthenticatedDashboardSmsUndeliveredRoute:
      AuthenticatedDashboardSmsUndeliveredRoute,
    AuthenticatedDashboardAnalyticsIndexRoute:
      AuthenticatedDashboardAnalyticsIndexRoute,
    AuthenticatedDashboardAuditLogIndexRoute:
      AuthenticatedDashboardAuditLogIndexRoute,
    AuthenticatedDashboardSupervisorIndexRoute:
      AuthenticatedDashboardSupervisorIndexRoute,
    AuthenticatedDashboardTicketsIndexRoute:
      AuthenticatedDashboardTicketsIndexRoute,
    AuthenticatedDashboardTicketsTicketIdIndexRoute:
      AuthenticatedDashboardTicketsTicketIdIndexRoute,
    AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute:
      AuthenticatedDashboardTicketsTicketIdHistoryIndexRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedSuperAdminRouteChildren {
  AuthenticatedSuperAdminTeamRoute: typeof AuthenticatedSuperAdminTeamRoute
  AuthenticatedSuperAdminOrganizationsOrgIdRoute: typeof AuthenticatedSuperAdminOrganizationsOrgIdRoute
  AuthenticatedSuperAdminOrganizationsNewRoute: typeof AuthenticatedSuperAdminOrganizationsNewRoute
  AuthenticatedSuperAdminAuditLogIndexRoute: typeof AuthenticatedSuperAdminAuditLogIndexRoute
  AuthenticatedSuperAdminOrganizationsIndexRoute: typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  AuthenticatedSuperAdminOverviewIndexRoute: typeof AuthenticatedSuperAdminOverviewIndexRoute
  AuthenticatedSuperAdminPlansIndexRoute: typeof AuthenticatedSuperAdminPlansIndexRoute
  AuthenticatedSuperAdminQrGeneratorIndexRoute: typeof AuthenticatedSuperAdminQrGeneratorIndexRoute
  AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute: typeof AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute
}

const AuthenticatedSuperAdminRouteChildren: AuthenticatedSuperAdminRouteChildren =
  {
    AuthenticatedSuperAdminTeamRoute: AuthenticatedSuperAdminTeamRoute,
    AuthenticatedSuperAdminOrganizationsOrgIdRoute:
      AuthenticatedSuperAdminOrganizationsOrgIdRoute,
    AuthenticatedSuperAdminOrganizationsNewRoute:
      AuthenticatedSuperAdminOrganizationsNewRoute,
    AuthenticatedSuperAdminAuditLogIndexRoute:
      AuthenticatedSuperAdminAuditLogIndexRoute,
    AuthenticatedSuperAdminOrganizationsIndexRoute:
      AuthenticatedSuperAdminOrganizationsIndexRoute,
    AuthenticatedSuperAdminOverviewIndexRoute:
      AuthenticatedSuperAdminOverviewIndexRoute,
    AuthenticatedSuperAdminPlansIndexRoute:
      AuthenticatedSuperAdminPlansIndexRoute,
    AuthenticatedSuperAdminQrGeneratorIndexRoute:
      AuthenticatedSuperAdminQrGeneratorIndexRoute,
    AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute:
      AuthenticatedSuperAdminQrGeneratorOrgIdLocationIdIndexRoute,
  }

const AuthenticatedSuperAdminRouteWithChildren =
  AuthenticatedSuperAdminRoute._addFileChildren(
    AuthenticatedSuperAdminRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedSuperAdminRoute: typeof AuthenticatedSuperAdminRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedSuperAdminRoute: AuthenticatedSuperAdminRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InvitationRoute: InvitationRoute,
  LoginRoute: LoginRoute,
  LoginMfaRoute: LoginMfaRoute,
  SetupMfaRoute: SetupMfaRoute,
  ActivateTokenRoute: ActivateTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
